import script from "./AILogoGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./AILogoGenerator.vue?vue&type=script&setup=true&lang=js"

import "./AILogoGenerator.vue?vue&type=style&index=0&id=2d4ad3d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4ad3d2"]])

export default __exports__